import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'
import { Box, Text, useBreakpointValue, Stack, HStack } from 'native-base'
import colors from 'app/colors'
import Svg from 'app/features/component/svg'

const IntroSection4 = () => {
	const { containerWidth } = useCommonResponsiveValues()

	const paddingY = useBreakpointValue({
		base: '48px',
		lg: '120px',
	})

	const textSize2Props = useBreakpointValue({
		base: 'h3/800',
		lg: 'h2/900',
	})

	const imgSrc1 = useBreakpointValue({
		base: {
			asset: require('app/assets/main/mobile_consultunt_img_01.svg'),
			src: '/main/mobile_consultunt_img_01.svg',
		},
		lg: {
			asset: require('app/assets/main/pc_consultunt_img_01.svg'),
			src: '/main/pc_consultunt_img_01.svg',
		},
	})

	const imgSrc2 = useBreakpointValue({
		base: {
			asset: require('app/assets/main/mobile_consultunt_img_02.svg'),
			src: '/main/mobile_consultunt_img_02.svg',
		},
		lg: {
			asset: require('app/assets/main/pc_consultunt_img_02.svg'),
			src: '/main/pc_consultunt_img_02.svg',
		},
	})

	const imgSrc3 = useBreakpointValue({
		base: {
			asset: require('app/assets/main/mobile_consultunt_img_03.svg'),
			src: '/main/mobile_consultunt_img_03.svg',
		},
		lg: {
			asset: require('app/assets/main/pc_consultunt_img_03.svg'),
			src: '/main/pc_consultunt_img_03.svg',
		},
	})

	const imgSrc4 = useBreakpointValue({
		base: {
			asset: require('app/assets/main/mobile_consultunt_img_04.svg'),
			src: '/main/mobile_consultunt_img_04.svg',
		},
		lg: {
			asset: require('app/assets/main/pc_consultunt_img_04.svg'),
			src: '/main/pc_consultunt_img_04.svg',
		},
	})

	return (
		<Box
			alignItems="center"
			py={paddingY}
			bgColor={{
				linearGradient: {
					colors: ['#000000cc', '#3D495A'],
					start: [1, 0],
					end: [1, 1],
				},
			}}
		>
			<Stack
				px={{ base: '16px', lg: '24px' }}
				py={{ base: '4px', lg: '8px' }}
				borderRadius="60px"
				borderWidth="2px"
				borderColor={colors.grey300}
			>
				<Text
					textAlign="center"
					color={colors.white50}
					size={useBreakpointValue({
						base: 'p_s/600',
						lg: 'h5/600',
					})}
				>
					지금 내 아이에게 종합학습진단이 필요한 이유
				</Text>
			</Stack>
			<Box h={{ base: '12px', lg: '24px' }} />
			<Text
				color={colors.white50}
				size={textSize2Props}
				textAlign="center"
			>
				대표 공부 컨설턴트의 {containerWidth.endsWith('%') && '\n'}
				한마디
			</Text>
			<Box h={{ base: '40px', lg: '60px' }} />

			<HStack alignItems="center" flexWrap="wrap" justifyContent="center">
				<Stack
					w={{ base: '300px', lg: '480px' }}
					h={{ base: '580px', lg: '484px' }}
					borderRadius="20px"
					bgColor={colors.black}
					mx="12px"
					my={{ base: '12px', lg: '30px' }}
				>
					<Svg
						width={useBreakpointValue({
							base: '300px',
							lg: '480px',
						})}
						height={useBreakpointValue({
							base: '140px',
							lg: '140px',
						})}
						asset={imgSrc1.asset}
						src={imgSrc1.src}
					/>
					<Stack py="32px" px="26px">
						<Text
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							01
						</Text>
						<Box h="24px" />
						<Text color={colors.white50} size="h7/700">
							{useBreakpointValue({
								lg: '고1 수학 모의고사 4등급 이하의 학생이\n고3 최종 수능에서 1등급으로  역전하는 비율은 고작 2%입니다.',
								base: '고1 수학 모의고사 4등급 이하의\n학생이  고3 최종 수능에서 1등급으로  역전하는 비율은 고작 2%입니다.',
							})}
						</Text>
						<Box h="24px" />
						<Text color={colors.grey500} size="p_m/500">
							{useBreakpointValue({
								lg: '공부는 스킬 싸움이 아닙니다. 습관 싸움입니다.\n범위가 기하급수적으로 늘어나는 고등학교 내신과\n수능공부라는 무거운 공을 잡을 수 있는 힘은\n고등학교 진학 전에 길러주어야 합니다.\n초등학교 고학년부터 중학교까지 학기별 공부량과\n과목별 비율까지 세부적으로 제시해 드립니다.',
								base: '공부는 스킬 싸움이 아닙니다.\n습관 싸움입니다.\n범위가 기하급수적으로 늘어나는 고등학교 내신과 수능공부라는 무거운 공을 잡을 수 있는 힘은 고등학교 진학 전에 길러주어야 합니다.\n초등학교 고학년부터 중학교까지 학기별 공부량과 과목별 비율까지 세부적으로\n제시해 드립니다.',
							})}
						</Text>
					</Stack>
				</Stack>
				<Stack
					w={{ base: '300px', lg: '480px' }}
					h={{ base: '580px', lg: '484px' }}
					borderRadius="20px"
					bgColor={colors.black}
					mx="12px"
					my={{ base: '12px', lg: '30px' }}
				>
					<Svg
						width={useBreakpointValue({
							base: '300px',
							lg: '480px',
						})}
						height={useBreakpointValue({
							base: '140px',
							lg: '140px',
						})}
						asset={imgSrc2.asset}
						src={imgSrc2.src}
					/>
					<Stack py="32px" px="26px">
						<Text
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							02
						</Text>
						<Box h="24px" />
						<Text color={colors.white50} size="h7/700">
							{useBreakpointValue({
								lg: '초3때 8시간의 공부 격차는 고3이 되면서\n12시간의 공부 격차로 벌어집니다.',
								base: '초3때 8시간의 공부 격차는\n고3이 되면서 12시간의 공부 격차로\n벌어집니다.',
							})}
						</Text>
						<Box h="24px" />
						<Text color={colors.grey500} size="p_m/500">
							{useBreakpointValue({
								lg: '대학 입시는 현실을 냉정하게 보아야 합니다.\n현재 다니고 있는 학교에서 전교 1등을 한다고 해서\nSKY에 진학할 수 있는 것은 아닙니다. 확률만 높은 것뿐입니다.\n학생의 공부 시간, 학습 가능 범위, 그리고 가장 중요한 학습의 패턴을\n분석한 후 현재 거주하고 있는 지역의 학습 성취도 및\n대학교 입결 결과 등을 반영하여 정교함을 더했습니다.',
								base: '대학 입시는 현실을 냉정하게 보아야\n합니다. 현재 다니고 있는 학교에서\n전교 1등을 한다고 해서 SKY에 진학할 수 있는 것은 아닙니다.\n확률만 높은 것뿐입니다. 학생의 공부\n시간, 학습 가능 범위, 그리고 가장 중요한 학습의 패턴을 분석한 후 현재 거주하고 있는 지역의 학습 성취도 및 대학교 입결 결과 등을 반영하여 정교함을 더했습니다.',
							})}
						</Text>
					</Stack>
				</Stack>
			</HStack>
			<HStack alignItems="center" flexWrap="wrap" justifyContent="center">
				<Stack
					w={{ base: '300px', lg: '480px' }}
					h={{ base: '580px', lg: '484px' }}
					borderRadius="20px"
					bgColor={colors.black}
					mx="12px"
					my={{ base: '12px', lg: '30px' }}
				>
					<Svg
						width={useBreakpointValue({
							base: '300px',
							lg: '480px',
						})}
						height={useBreakpointValue({
							base: '140px',
							lg: '140px',
						})}
						asset={imgSrc3.asset}
						src={imgSrc3.src}
					/>
					<Stack py="32px" px="26px">
						<Text
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							03
						</Text>
						<Box h="24px" />
						<Text color={colors.white50} size="h7/700">
							{useBreakpointValue({
								lg: '특목고 진학 70명인 중학교와, 0명인 중학교의 전교1등은\n완벽히 다르게 정의 내려져야만 합니다!',
								base: '특목고 진학 70명인 중학교와,\n0명인 중학교의 전교1등은 완벽히\n다르게 정의 내려져야만 합니다!',
							})}
						</Text>
						<Box h="24px" />
						<Text color={colors.grey500} size="p_m/500">
							{useBreakpointValue({
								lg: '학생의 공부시간, 학습 가능 범위, 학습 패턴 및 성향을 1차 반영하고\n지역별 학업 성취도를 2차 적용하여 전국 단위에서 학생의 성적을\n분석합니다.\n또한, 현재와 같은 공부 패턴을 유지했을 경우\n중고등학교의 성적까지도 예측합니다.',
								base: '학생의 공부시간, 학습 가능 범위, 학습 패턴 및 성향을 1차 반영하고 지역별 학업 성취도를 2차 적용하여 전국 단위에서\n학생의 성적을 분석합니다.\n또한, 현재와 같은 공부 패턴을 유지했을 경우 중고등학교의 성적까지도 예측합니다.',
							})}
						</Text>
					</Stack>
				</Stack>
				<Stack
					w={{ base: '300px', lg: '480px' }}
					h={{ base: '580px', lg: '484px' }}
					borderRadius="20px"
					bgColor={colors.black}
					mx="12px"
					my={{ base: '12px', lg: '30px' }}
				>
					<Svg
						width={useBreakpointValue({
							base: '300px',
							lg: '480px',
						})}
						height={useBreakpointValue({
							base: '140px',
							lg: '140px',
						})}
						asset={imgSrc4.asset}
						src={imgSrc4.src}
					/>
					<Stack py="32px" px="26px">
						<Text
							color={colors.green400}
							size={useBreakpointValue({
								base: 'h6/800',
								lg: 'h5/800',
							})}
						>
							04
						</Text>
						<Box h="24px" />
						<Text color={colors.white50} size="h7/700">
							{useBreakpointValue({
								lg: '학원은 무조건 다녀야 하는 곳이 아니라\n‘선택’해서 ‘이용’해야 하는 곳입니다!',
								base: '학원은 무조건 다녀야 하는 곳이\n아니라 ‘선택’해서 ‘이용’ 해야\n하는 곳입니다!',
							})}
						</Text>
						<Box h="24px" />
						<Text color={colors.grey500} size="p_m/500">
							{useBreakpointValue({
								lg: '초~중 과정은 대입의 골격이 정해지는 중요한 시기입니다.\n학원이 ‘그냥‘, ‘잘 가르친다니까’ 다니는 곳이 되면 아이의 소중한 시간과 \n돈만 허비하는 곳이 됩니다.\n학원은 학생의 성향과 상황에 따라 선택해서 이용해야 하는 곳입니다.\n종합진단평가에서는 학생과 학원의 적합도를 분석해\n최적의 대안을 제시해 드립니다.',
								base: '초~중 과정은 대입의 골격이 정해지는\n중요한 시기입니다.\n학원이 ‘그냥‘, ‘잘 가르친다니까’\n다니는 곳이 되면 아이의 소중한 시간과\n돈만 허비하는 곳이 됩니다.\n학원은 학생의 성향과 상황에 따라\n선택해서 이용해야 하는 곳입니다.\n종합진단평가에서는 학생과 학원의 적합도를\n분석해 최적의 대안을 제시해 드립니다.',
							})}
						</Text>
					</Stack>
				</Stack>
			</HStack>
		</Box>
	)
}

export default IntroSection4
